import React, { useEffect, useState } from 'react'
import useSetCurrentUser from '../../hooks/useSetCurrentUser'
import AuthPageLayout from '../../layout/auth_page_layout'
import Typography from '../../components/typography'
import { AuthService } from '../../apilibrary'
import useCurrentUserId from '../../hooks/useCurrentUserId'
import { trackUserLogout } from '../../utils/analytics'

enum LogoutState {
  LOGGING_OUT,
  LOGOUT_SUCCESSFUL,
  LOGOUT_FAILED,
}

const LogoutPage: React.FC = () => {
  const [logoutState, setLogoutState] = useState<LogoutState>(LogoutState.LOGGING_OUT)
  const [error, setError] = useState<string>()
  const setUser = useSetCurrentUser()
  const userId = useCurrentUserId();

  useEffect(() => {
    const logout = async (): Promise<void> => {
      try {
        setLogoutState(LogoutState.LOGGING_OUT)
        await AuthService.signout()
        setLogoutState(LogoutState.LOGOUT_SUCCESSFUL)
        await trackUserLogout(userId as string);
        setUser(undefined)
      } catch (e) {
        setLogoutState(LogoutState.LOGOUT_FAILED)
        if (e instanceof Error) {
          setError(e.message)
        }
        setError('Something went wrong')
      }
    }
    void logout()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AuthPageLayout title='Logout'>
      {logoutState === LogoutState.LOGGING_OUT && <Typography textAlign={'center'}>Logging out...</Typography>}
      {logoutState === LogoutState.LOGOUT_SUCCESSFUL && <Typography textAlign={'center'}>Logout Successful</Typography>}
      {logoutState === LogoutState.LOGOUT_FAILED && <Typography textAlign={'center'} color={'error'}>{error}</Typography>}
    </AuthPageLayout>
  )
}

export default LogoutPage
